import { useIsLargeScreen } from '@jfs/utils'
import { useNavigation } from '@react-navigation/native'
import { FC, useCallback, useState } from 'react'
import { ViewStyle } from 'react-native'
import { LinearGradientContainer } from '../../../comps/LinearGradient'
import { Modal, ModalTypes } from '../../../comps/ModalWeb'
import { ModBox } from '../../../comps/ModifiedBox/ModifiedBox'
import { Routes } from '../../../nav/routes'
import { Colors, isMobile } from '../../../util/util'
import Navbar from '../NavBar'
import Menu from './Menu'
import { stylesHeader } from './styles'

export interface SearchMenuViewProps {
  title?: string
  path: string
  hide?: boolean
  onSearchResultClicked: (show: any, txnId: string, txnDate?: string) => void
  hideSearchBar?: boolean
  isSuperMerchant?: boolean
}

export interface SearchViewProps {
  title?: string
  path: string
  type?: any
  onSearchResultClicked: (show: boolean, txnId: string, txnDate: string) => void
}

const Header: FC<SearchMenuViewProps> = ({
  path,
  hide = false,
  onSearchResultClicked,
  hideSearchBar = false,
  isSuperMerchant,
}: SearchMenuViewProps) => {
  const isLarge = useIsLargeScreen()
  const { navigate } = useNavigation()
  const setTxnDetailsVisibility = useCallback(
    (value, txnId, txnDate) => onSearchResultClicked(value, txnId, txnDate),
    [onSearchResultClicked],
  )

  const handleSearchResultClick = (show: boolean, txnId: string, txnDate: string) => {
    setTxnDetailsVisibility(show, txnId, txnDate)
  }
  const themedStyle = stylesHeader(0)
  const [navVisible, setNavVisible] = useState(false)

  const handleNav = (): void => {
    setNavVisible((prev) => !prev)
  }

  const setVisiblity = (): void => {
    setNavVisible(false)
  }

  const onPress = (item: any): void => {
    navigate((item && item?.navigateTo) || Routes.PROFILE)
    setNavVisible((prev) => !prev)
  }

  const Nav = (
    <LinearGradientContainer
      customStyle={themedStyle.gradientBgStyle as ViewStyle}
      colorArray={[Colors.DARK_BLUE, Colors.PRIMARY]}
      direction="HORIZONTAL">
      <Navbar onPress={onPress} isSuperMerchant={isSuperMerchant} />
    </LinearGradientContainer>
  )

  if (hide) {
    return null
  }

  return (
    <ModBox {...themedStyle.container} show={!isMobile(isLarge)}>
      <Modal view={Nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR} />
      <Menu
        handleNav={handleNav}
        navigate={navigate}
        path={path}
        onSearchResultClicked={handleSearchResultClick}
        hideSearchBar={hideSearchBar}
      />
    </ModBox>
  )
}

export default Header
